var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sm-fly-btn-list", staticStyle: { height: "0" } },
    [
      _c(
        "button",
        {
          staticClass: "sm-btn sm-fly-btn",
          attrs: { title: _vm.playing ? "暂停" : "开始", type: "button" },
          on: { click: _vm.toggleFly }
        },
        [
          _vm.playing
            ? _c("i", { staticClass: "el-icon-video-pause" })
            : _c("i", { staticClass: "el-icon-video-play" })
        ]
      ),
      _c(
        "button",
        {
          staticClass: "sm-btn sm-fly-btn",
          attrs: { title: "结束", type: "button" },
          on: { click: _vm.stopFly }
        },
        [_c("i", { staticClass: "el-icon-switch-button" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }